import "../../../../App.css";
import { RouterProps } from "react-router-dom";
import Helper from "../../../../Common/Helper";
import { TablePanelInfo } from "../../../../Components/Headings/TableHeading/TablePanelInfo"
import { appContext } from "../../../../AppContext";
import { rights } from "../../../../Common/RightsManager";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import { Roles } from "./DataModels";
import IbssDataGrid from "../../../../Components/Data/DataGrid/IbssDataGrid";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import IbssActionButton, { IActionButton } from "../../../../Components/Buttons/ActionButton/IbssActionButton";
import IbssSvgIcon from "../../../../Components/Icons/SvgIcon/IbssSvgIcon";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AddIcon from "../../../../Components/Icons/AddIcon";
import { Box } from "@mui/material";
import IbssFilter from "../../../../Components/Forms/Filter/IbssFilter";

export class ListRoles extends IbssPage<IProps, IState>
{

  private get labels() { return appContext().labels; }

  private userCanCreate: boolean;
  private userCanDelete: boolean;

  private columns = [
    {
      field: Helper.nameOf<Roles>("name"),
      headerName: this.labels.HubLabelName,
      flex: 1
    },
    {
      field: Helper.nameOf<Roles>("identityProviderName"),
      headerName: this.labels.HubLabelIdentityprovider,
      flex: 1
    },
    {
      field: Helper.nameOf<Roles>("securityProviderTypeName"),
      headerName: this.labels.HubLabelType,
      flex: 1,
    },
    {
      field: Helper.nameOf<Roles>("isOwner"),
      headerName: this.labels.HubLabelIsOwner,
      flex: 1,
      renderCell: (params: { row: Roles }) => <>{params.row.isOwner == 1 ? this.labels.HubLabelYes_S : this.labels.HubLabelNo_S}</>
    }
  ];

  constructor(props: IProps)
  {
    super(props);
    this.state = {
      isLoading: false,
      roles: [],
      selectedRows: [],
      searchTerm: ''
    };

    this.userCanCreate = rights.DATAMODEL.Roles.Create.has();
    this.userCanDelete = rights.DATAMODEL.Roles.Delete.has();
  }

  public async componentDidMount(): Promise<void>
  {
    this.pageTitle = this.labels.HubMenuSecurity;
    await this.getRoles()
  }

  private async getRoles(): Promise<void>
  {
    this.setState({ isLoading: true, });
    try
    {
      const roles = await appContext().webEntryApiClientV1.api.webentry.v1.security.roles.get<Roles[]>({});
      this.setState({ isLoading: false, roles: roles })
    } catch (error)
    {
      this.setState({ isLoading: false });
    }
  }

  private onRowClick(id: string): void
  {
    this.props.history.push(`security-roles/rolesdetails/${id}`);
  }

  private filterRows(searchTerm: string): Roles[] 
  {
    const filteredRows = this.state.roles.filter(x =>
    {
      let key: keyof Roles;
      for (key in x)
      {
        if (x[key]?.toString().toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()) && (key == 'name' || key == 'identityProviderName' || key == 'securityProviderTypeName'))
        {
          return true;
        }
      }
      return false;
    });
    return filteredRows;
  }

  private async deleteClicked(): Promise<void>
  {
    this.setState({ isLoading: true });
    try
    {
      let index = 0;
      while (index < this.state.selectedRows.length)
      {
        await appContext().webEntryApiClientV1.api.webentry.v1.security.roles.byRoleid.delete({
          roleid: this.state.roles.filter(x => x.id == this.state.selectedRows[index])[0].id
        });
        index = index + 1
      }
      await this.getRoles();
      this.setState({ isLoading: false, selectedRows: [] });
    } catch (error)
    {
      this.setState({ isLoading: false });
    }
  }

  public render(): JSX.Element
  {

    const actionButtons: IActionButton[] =
      [
        {
          label: this.labels.HubButtonDelete,
          icon: (
            <IbssSvgIcon>
              <DeleteOutlinedIcon />
            </IbssSvgIcon>
          ),
          color: "error",
          onClick: () => this.deleteClicked(),
          disabled: !this.userCanDelete || this.state.selectedRows.length == 0
        },
        {
          label: this.labels.HubButtonAdd,
          className: "addIcon",
          icon: (
            <IbssSvgIcon>
              <AddIcon />
            </IbssSvgIcon>
          ),
          color: "primary",
          disabled: this.userCanCreate === false,
          onClick: () => this.props.history.push("security-roles/rolesdetails/0"),
        },
      ];

    const filteredRows = this.filterRows(this.state.searchTerm);

    return (
      <div className="rightPanel-main-content">
        <div className="table-panel">
          <TablePanelInfo
            tableHeading={this.labels.HubLabelRoles}
            iconSrc="User"
          />
          <IbssFilter
            searchTerm={this.state.searchTerm}
            onSearchTermChange={(event) => this.setState({ searchTerm: event.target.value })}
          />
          <Box component="div" sx={{ display: 'flex', justifyContent: 'right', alignItems: 'center', my: 1, mr: 0 }}>
            <IbssActionButton buttons={actionButtons} />
          </Box>
          <IbssDataGrid
            className="data-grid-clickable-row"
            loading={this.state.isLoading}
            columns={this.columns}
            rows={filteredRows}
            disableRowSelectionOnClick
            onRowClick={(params) => this.onRowClick(params.row.id)}
            checkboxSelection
            onRowSelectionModelChange={(rowSelectionModel: GridRowSelectionModel) => this.setState({ selectedRows: rowSelectionModel })}
            rowSelectionModel={this.state.selectedRows}
          />
        </div>
      </div>
    );
  }
}

export interface IState
{
  isLoading: boolean;
  roles: Roles[];
  selectedRows: GridRowSelectionModel;
  searchTerm: string;
}

export interface IProps extends RouterProps
{
}

export default ListRoles;